import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { getBackgroundColor } from '@magalu/stereo-ui-styles';
import Box from '@magalu/stereo-ui/atoms/Box';
import styled from 'styled-components';
export var Content = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-top-width: 4px;\n  border-top-style: solid;\n  border-top-color: ", ";\n"])), function (props) {
  return getBackgroundColor('darker')(props);
});